// eslint-disable-next-line no-extend-native
Date.prototype.Format = function (fmt) {
  const o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds(), // 毫秒
  };
  // eslint-disable-next-line no-param-reassign
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (`${this.getFullYear()}`).substr(4 - RegExp.$1.length));
  // eslint-disable-next-line no-param-reassign
  for (const k in o) { if (new RegExp(`(${k})`).test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length))); }
  return fmt;
};

const filters = {
  dateTime(time) {
    if (time) {
      const odate = new Date();
      odate.setTime(time);
      const year = odate.getFullYear();
      const M = odate.getMonth() + 1;
      const d = odate.getDate();
      // const h = odate.getHours();
      // const m = odate.getMinutes();
      // const s = odate.getSeconds();
      // const w = odate.getDay();
      const month = M < 10 ? `0${M}` : M;
      const day = d < 10 ? `0${d}` : d;
      // const hours = h < 10 ? `0${h}` : h;
      // const minutes = m < 10 ? `0${m}` : m;
      // const seconds = s < 10 ? `0${s}` : s;
      // const weeks = ['日', '一', '二', '三', '四', '五', '六'];
      // const week = `星期${weeks[w]}`;
      return `${year}-${month}-${day} `;
    }
  },
  filterSource(key) {
    switch (key) {
      case '0':
        return '未知';
      case '-1':
        return '全部';
      case '1':
        return '电脑端';
      default:
        return '';
    }
  },

};

export default function install(Vue) {
  Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key]);
  });
}
